var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.21997C0 4.59043 0.447715 4.08008 1 4.08008H23C23.5523 4.08008 24 4.59043 24 5.21997V20.4993C24 21.1289 23.5523 21.5991 23 21.5991H19.4525V19.5991H22V6H2V20H4.45583V22H1C0.447715 22 0 21.5297 0 20.9001V5.21997Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9244 22.441H8.98438V20.4009H14.9244V22.441Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72022 19.3809C6.02204 19.3809 5.45605 19.9582 5.45605 20.6704C5.45605 21.3826 6.02204 21.9599 6.72022 21.9599C7.4184 21.9599 7.98439 21.3826 7.98439 20.6704C7.98439 19.9582 7.4184 19.3809 6.72022 19.3809ZM3.45605 20.6704C3.45605 18.8315 4.91747 17.3408 6.72022 17.3408C8.52297 17.3408 9.98439 18.8315 9.98439 20.6704C9.98439 22.5093 8.52297 24 6.72022 24C4.91747 24 3.45605 22.5093 3.45605 20.6704Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1885 19.3809C16.4903 19.3809 15.9243 19.9582 15.9243 20.6704C15.9243 21.3826 16.4903 21.9599 17.1885 21.9599C17.8867 21.9599 18.4526 21.3826 18.4526 20.6704C18.4526 19.9582 17.8867 19.3809 17.1885 19.3809ZM13.9243 20.6704C13.9243 18.8315 15.3857 17.3408 17.1885 17.3408C18.9912 17.3408 20.4526 18.8315 20.4526 20.6704C20.4526 22.5093 18.9912 24 17.1885 24C15.3857 24 13.9243 22.5093 13.9243 20.6704Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15.3006C4.44772 15.3006 4 14.8529 4 14.3006V4.06006C4 3.50777 4.44772 3.06006 5 3.06006C5.55228 3.06006 6 3.50777 6 4.06006V14.3006C6 14.8529 5.55228 15.3006 5 15.3006Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15.3006C8.44772 15.3006 8 14.8529 8 14.3006V4.06006C8 3.50777 8.44772 3.06006 9 3.06006C9.55228 3.06006 10 3.50777 10 4.06006V14.3006C10 14.8529 9.55228 15.3006 9 15.3006Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 12H8.87333V14.0401H5.5V12Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8H9V10H5V8Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2621 2.0401C15.9285 2.04063 15.6085 2.17572 15.3721 2.41594C15.1355 2.65621 15.0018 2.98216 15 3.32264V5.19036H13V3.31614C13.0035 2.43544 13.3489 1.59197 13.9607 0.97045C14.5725 0.348938 15.4008 -7.17423e-06 16.2642 1.10626e-10L16.2642 1.02005L16.2682 8.32965e-06C17.1294 0.00355756 17.9542 0.354114 18.5631 0.975221C19.1721 1.59635 19.5157 2.43776 19.5192 3.31615L19.5192 3.32027L19.5192 5.19036H17.5192V3.32264C17.5174 2.98308 17.3843 2.65792 17.1489 2.41779C16.9136 2.1777 16.5949 2.04201 16.2621 2.0401Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0002 11L17.0001 5.27539H15.0001L15.0002 12.02C15.0002 12.5834 15.448 13.0401 16.0002 13.0401L23.0002 13.04V10.9999L17.0002 11Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.e9d8d29fd101325f326e1a75eb1a7d07.svg";
export { ForwardRef as ReactComponent };